const routes = [
    {
        path: '/',
        name: 'Verify',
        component: () => import('@/pages/Login/Verification'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/verify',
        name: 'Verify',
        component: () => import('@/pages/Login/Verification'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/verify-ecp',
        name: 'VerifyEcp',
        component: () => import('@/pages/Login/VerificationEcp'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/admin-login',
        name: 'Login',
        component: () => import('@/pages/Login/Login'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/logout',
        name: 'Logout',
        component: () => import('@/pages/Login/Logout'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/error404',
        name: 'Error404',
        component: () => import('@/pages/Error/Error404'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/error401',
        name: 'Error401',
        component: () => import('@/pages/Error/Error401'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/wait-account-configuration',
        name: 'ErrorWaitAccountConfiguration',
        component: () => import('@/pages/Error/ErrorWaitAccountConfiguration'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/sso',
        name: 'SSO',
        component: () => import('@/pages/Login/SSO'),
        meta: {
            roles: '*',
        },
    },
    {
        path: '/',
        name: 'LayoutPublic',
        component: () => import('@/components/Layout/LayoutPublic'),
        children: [
            {
                path: '/login',
                name: 'PasswordlessLogin',
                component: () => import('@/pages/Login/PasswordlessLogin'),
                meta: {
                    roles: '*',
                },
            },
            {
                path: '/forgot-identifiers',
                name: 'ForgotIdentifiers',
                component: () => import('@/pages/Login/ForgotIndentifiers'),
                meta: {
                    roles: '*',
                },
            },
            {
                path: '/magiclink/:url',
                name: 'MagicLink',
                component: () => import('@/pages/Login/MagicLink'),
                meta: {
                    roles: '*',
                },
            },
            {
                path: '/find-identifiers',
                name: 'FindIdentifiers',
                component: () => import('@/pages/Login/FindIndentifiers'),
                meta: {
                    roles: '*',
                }
            },
            {
                path: '/configuration-infos',
                name: 'ConfigurationInfos',
                component: () => import('@/pages/Login/ConfigurationInfos'),
                meta: {
                    roles: '*',
                    ecpToken: true,
                },
            },
        ],
    },
    {
        path: '/app',
        name: 'Layout',
        component: () => import('@/components/Layout/Layout'),
        children: [
            {
                path: 'dashboard',
                name: 'Dashboard',
                component: () => import('@/pages/Dashboard/Dashboard'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'quarantine',
                name: 'Quarantine',
                component: () => import('@/pages/Quarantine/Quarantine'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'alert',
                name: 'Alert',
                component: () => import('@/pages/Alert/Alert'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'gestion',
                name: 'Gestion',
                component: () => import('@/pages/Gestion/Gestion'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'installation',
                name: 'Installation',
                component: () => import('@/pages/Installation/Installation'),
                meta: {
                    roles: 'ADMIN|CUSTOMER|COLLABORATOR',
                },
            },
            {
                path: 'account',
                name: 'Account',
                component: () => import('@/pages/Account/Account'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'modify-infos',
                name: 'ModifyInfos',
                component: () => import('@/pages/Account/ModifyInfos'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'faq',
                name: 'FAQ',
                component: () => import('@/pages/FAQ/FAQ'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'accounts',
                name: 'Accounts',
                component: () => import('@/pages/Accounts/Accounts'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            }
        ],
    },
    {
        path: '/admin',
        name: 'Admin',
        component: () => import('@/components/Layout/LayoutAdmin'),
        children: [
            {
                path: 'dashboard',
                name: 'DashboardMirror',
                component: () => import('@/pages/Dashboard/Dashboard'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'quarantine',
                name: 'QuarantineMirror',
                component: () => import('@/pages/Quarantine/Quarantine'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'alert',
                name: 'AlertMirror',
                component: () => import('@/pages/Alert/Alert'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'gestion',
                name: 'GestionMirror',
                component: () => import('@/pages/Gestion/Gestion'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'account',
                name: 'AccountMirror',
                component: () => import('@/pages/Account/Account'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'installation',
                name: 'InstallationMirror',
                component: () => import('@/pages/Installation/Installation'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            },
            {
                path: 'customer',
                name: 'Customer',
                component: () => import('@/pages/Admin/Customer/Customer'),
                meta: {
                    roles: 'ADMIN|CUSTOMER',
                },
            }
        ],
    },

]

export default routes
